import {ReactComponent as UniEsfIcon} from './uniEsf.svg'

function UniEsf() {
  return <UniEsfIcon />
}

export default UniEsf
